/* tslint:disable */
/* eslint-disable */
/**
 * Prebooking service API
 * Service provides pre booking functionality for long term reservations.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AppErrorDto
 */
export interface AppErrorDto {
    /**
     * 
     * @type {string}
     * @memberof AppErrorDto
     */
    errorCode: string;
    /**
     * 
     * @type {string}
     * @memberof AppErrorDto
     */
    detailCode: string;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof AppErrorDto
     */
    parameters?: { [key: string]: object; };
}

/**
 * Check if a given object implements the AppErrorDto interface.
 */
export function instanceOfAppErrorDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "errorCode" in value;
    isInstance = isInstance && "detailCode" in value;

    return isInstance;
}

export function AppErrorDtoFromJSON(json: any): AppErrorDto {
    return AppErrorDtoFromJSONTyped(json, false);
}

export function AppErrorDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AppErrorDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'errorCode': json['errorCode'],
        'detailCode': json['detailCode'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
    };
}

export function AppErrorDtoToJSON(value?: AppErrorDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'errorCode': value.errorCode,
        'detailCode': value.detailCode,
        'parameters': value.parameters,
    };
}

